import { CLUSTER_API } from '../API/BASE_URL';

export const getResidents = async () => {
  const response = await fetch(CLUSTER_API + 'residents/', {
    method: 'GET',
  });

  const data = await response.json();
  return data;
};
